<div class="container-question flex space-x-3 my-5">
  <img [src]="logo" class="logoPosition-h" />
  <div *ngIf="question" class="title-question inline-block align-middle my-auto">
    <span [innerHTML]="question.libelle" class="whitespace-pre-line"></span>
    <app-popup-info *ngIf="popupInfo" [popUpInfo]="popupInfo"></app-popup-info>
    <app-popup-info *ngIf="popupInfoHA" [popUpInfoHA]="popupInfoHA"></app-popup-info>
  </div>
</div>
